import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL, IHierarchyNode } from '@/dtos';

export const QUERY_KEY = 'useClaimTeamsHierarchyQueryKey';

export interface ClaimTeamsHierarchyResponseDto {
  id: number;
  name: string;
  matchesQuery: boolean;
  children: ClaimTeamsHierarchyResponseDto[];
}

export interface ClaimTeamsHierarchy {
  id: string;
  name: string;
  matchesQuery: boolean;
  children: ClaimTeamsHierarchy[];
}

const formatData = (data: IHierarchyNode): ClaimTeamsHierarchy =>
  ({
    ...data,
    ...(typeof data?.id === 'number' ? { id: toString(data.id) } : {}),
    ...(data?.children ? { children: data.children.map((item) => formatData(item)) } : {}),
  }) as ClaimTeamsHierarchy;

const useClaimTeamsHierarchyQuery = (claimTeamId?: string) => {
  const { isLoading, isSuccess, isError, data, refetch, isRefetching } = useQuery(
    [QUERY_KEY, claimTeamId],
    claimTeamId
      ? () => api.get(API_URL.ORGANIZATIONS_CLAIMS_TEAM_HIERARCHY_BY_CLAIMS_TEAM_ID(claimTeamId))
      : () => null
  );

  const formattedData = useMemo(() => (data?.data ? formatData(data.data) : undefined), [data]);

  return {
    formattedData,
    isError,
    isLoading,
    isSuccess,
    refetch,
    isRefetching,
  };
};

export default useClaimTeamsHierarchyQuery;
